import {
  Box,
  DialogContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PostAddIcon from '@mui/icons-material/PostAdd';
import {
  CustomButton,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../../common/components';

const AdditionalsTab = ({
  localContract,
  isArchived,
  isReadOnly = false,
  handleOpenAdditionalDialog,
  handleEditAdditional,
  handleDeleteAdditional,
}) => {
  const disableEdition = isReadOnly || isArchived;

  return (
    <Box sx={{ minHeight: '480px', minWidth: '1099px' }}>
      <DialogContent sx={{ display: 'flex' }}>
        <Box sx={{ width: '100%' }}>
          <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: 4 }}>
            <Box>
              <CustomButton
                variant="contained"
                onClick={handleOpenAdditionalDialog}
                buttonIcon={PostAddIcon}
                sx={{ marginBottom: '10px' }}
                disabled={disableEdition}
              >
                Agregar Adicional
              </CustomButton>

              <GeneralTableBox sx={{ boxShadow: '5px 5px 20px rgba(1,2,10,0.3)', width: '100%' }}>
                <Table aria-label="additionals table">
                  <TableHead>
                    <TableRow>
                      <HeadTableCell>Descripción</HeadTableCell>
                      <HeadTableCell>Detalle</HeadTableCell>
                      <HeadTableCell>Importe</HeadTableCell>
                      <HeadTableCell>Cuota Actual</HeadTableCell>
                      <HeadTableCell>Cuota Final</HeadTableCell>
                      <HeadTableCell wmd="150px">Acciones</HeadTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(localContract.additionals || []).map((additional, key) => (
                      <TableRow key={key}>
                        <RowTableCell>{additional?.additional?.name || ''}</RowTableCell>
                        <RowTableCell>{additional?.description || ''}</RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {additional?.amount || ''}
                        </RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {additional?.current_fee || ''}
                        </RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {additional?.final_fee || ''}
                        </RowTableCell>
                        <RowTableCell
                          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <CustomButton
                            variant="contained"
                            onClick={() => handleEditAdditional(additional)}
                            disabled={disableEdition}
                            sx={{ width: '40px', height: '40px', marginRight: '5px' }}
                          >
                            <IconButton size="small">
                              <EditIcon sx={{ color: 'whitesmoke' }} />
                            </IconButton>
                          </CustomButton>
                          <CustomButton
                            variant="danger"
                            onClick={() => handleDeleteAdditional(additional.uuid)}
                            disabled={disableEdition}
                            sx={{ width: '40px', height: '40px' }}
                          >
                            <IconButton size="small">
                              <DeleteIcon sx={{ color: 'whitesmoke' }} />
                            </IconButton>
                          </CustomButton>
                        </RowTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </GeneralTableBox>
            </Box>
          </Grid>
        </Box>
      </DialogContent>
    </Box>
  );
};

export default AdditionalsTab;
